import { render, staticRenderFns } from "./aftersale_outlet_list.vue?vue&type=template&id=580a7f91&scoped=true"
import script from "./aftersale_outlet_list.vue?vue&type=script&lang=js"
export * from "./aftersale_outlet_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a7f91",
  null
  
)

export default component.exports